/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';
import {APIType} from '../../interface/tableAPIType';
import {getRoute, tableAPIMethod} from '../../utils/tableAPIMethod';

const facilityDetails = async (
  type: APIType,
  shouldCall: boolean = true,
  data: any = undefined,
  id: string = ''
): Promise<any> => {
  const token = useUserStore.getState().userToken;

  const facilityDetails = useCompanyStore.getState().facilityDetails;

  if (Object.keys(facilityDetails).length === 0 || shouldCall) {
    try {
      const res = await axios.request({
        method: tableAPIMethod(type),
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.facilityDetailsDropdown}${
          data === 'company' ? '/company' : ''
        }/${getRoute(type, id)}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: data ?? {}
      });

      useCompanyStore.setState({
        facilityDetails: res.data.data?.[0] ?? {}
      });

      return res.data.data?.[0];
    } catch (err: any) {
      const data = err?.response?.data;
      const message = data?.message || 'Something went wrong';
      const reloadSubscription = data?.reloadSubscription === true;
      const reloadType = data?.reloadType;

      return {status: 'error', message, reloadSubscription, reloadType};
    }
  }
};

export default facilityDetails;
